import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from '../../store/IApplicationState';
import { ServiceCenter } from '../../models/utilities/service-center';

// #region Component Props

interface IProps {
    children                : any;
    currentServiceCenters   : string[];
    selectedServiceCenter   : ServiceCenter;
    requiredServiceCenters? : string[];
}

// #endregion

/**
 * Component for hiding content based on user having a service center
 */
class HasServiceCenterComponent extends React.Component<IProps> {

    public static defaultProps = {
        currentServiceCenters: [],
        requiredServiceCenters: [],
        selectedServiceCenter: undefined
    };

    public render() {

        const { 
            children, 
            currentServiceCenters, 
            selectedServiceCenter,
            requiredServiceCenters 
        } = this.props;

        // Requires a specific service center
        if (requiredServiceCenters && requiredServiceCenters.length > 0) {

            if (requiredServiceCenters.indexOf(selectedServiceCenter.name) >= 0 ||
                selectedServiceCenter.name === 'ALL') {
                return <React.Fragment>{children}</React.Fragment>;
            }
            else {
                return null;
            }
        }

        // Requires any serevice center
        if (currentServiceCenters && currentServiceCenters.length > 0) {
            return <React.Fragment>{children}</React.Fragment>;
        }
        else {
            return null;
        }
        
    }

}

const mapStateToProps = (extendState = {}) => (state: IApplicationState) => {
    return {
        currentServiceCenters: state.userdata.user.serviceCenters,
        selectedServiceCenter: state.userdata.activeServiceCenter,
        ...extendState
    };
};

const HasServiceCenters = connect(
    mapStateToProps,
    null
)(HasServiceCenterComponent);

export { HasServiceCenters };
